import * as actionTypes from 'src/old/actions';

const initialState = { menuOpened: undefined };

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.OPEN_MENU: {
      return {
        menuOpened: true
      };
    }
    case actionTypes.CLOSE_MENU: {
      return {
        menuOpened: false
      };
    }

    default: {
      return state;
    }
  }
};

export default menuReducer;
